<template>
  <vx-card>
    <h4>{{ $t('faq.all-unit') }} </h4>
    <ul class="faq-topics mt-5">
      <li class="p-2 font-medium flex items-center" @click="$emit('onFilterUnitClick','')">
        <span class="h3 text-primary mr-2"><b-icon-dot></b-icon-dot></span>
        <span class="cursor-pointer hover:text-primary"
              :class="{'text-primary': !faqFilter}">
          {{ $t('faq.filter-all-unit') }}
        </span>
      </li>
      <li :key="unit.id"
          class="p-2 font-medium flex items-center"
          @click="$emit('onFilterUnitClick',unit.id)"
          v-for="unit in courseOutlineUnits">
        <span class="h3 text-primary mr-2"><b-icon-dot></b-icon-dot></span>
        <span class="cursor-pointer hover:text-primary"
              :class="{'text-primary': unit.id === faqFilter}">
          {{ unit.seq }}. {{ unit.nameLocal }}
        </span>
      </li>
    </ul>
  </vx-card>
</template>

<script>
  import { BIconDot } from 'bootstrap-vue'
  export default {
    name: "FilterUnit",
    props: [
      'courseOutlineUnits',
      'currentFocusUnit',
      'faqFilter',
    ],
    components:{
      BIconDot,
    },
  }
</script>

<style scoped>

</style>
